"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = create;
var _baseCreate = _interopRequireDefault(require("./_baseCreate.js"));
var _extendOwn = _interopRequireDefault(require("./extendOwn.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Creates an object that inherits from the given prototype object.
// If additional properties are provided then they will be added to the
// created object.
function create(prototype, props) {
  var result = (0, _baseCreate.default)(prototype);
  if (props) (0, _extendOwn.default)(result, props);
  return result;
}